var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { Autocomplete, Link, Spacer, Typography } from '@emburse/ui-core';
import { CardIssuingApiService } from '@ClientApi/cardIssuing';
const MerchantCategoryCodesFieldHelperText = () => {
    return (_jsxs(Typography, Object.assign({ variant: "caption", style: { paddingLeft: '12px' } }, { children: ["Click", ' ', _jsx(Link, Object.assign({ href: window.whitelabelConfiguration.supportLinks.merchantCategoryGroups, target: "_blank", rel: "noopener noreferrer" }, { children: "Here" })), ' ', "to learn more about Merchant Category Groups.", ' '] })));
};
export const MerchantCategoryCodesField = ({ defaultValue = [], onChange, multiple = true, disabled }) => {
    const [options, setOptions] = React.useState([]);
    const [value, setValue] = React.useState([]);
    React.useEffect(() => {
        function getMerchantCategoryCodes() {
            return __awaiter(this, void 0, void 0, function* () {
                const codes = yield CardIssuingApiService.getMerchantCategoryOptions();
                const codesWithLabels = codes.map((code) => ({ label: code.description, value: code.groupCode }));
                const sortedCodes = codesWithLabels.sort((a, b) => a.label.localeCompare(b.label));
                setOptions(sortedCodes);
                setValue(sortedCodes.filter((option) => defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.includes(option.value)));
            });
        }
        getMerchantCategoryCodes();
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(Autocomplete, { label: 'Allowed Merchant Category Groups', multiple: multiple, showCheckbox: true, limitTags: 2, disableCloseOnSelect: true, disabled: disabled, 
                // AW-4720 / ANGULAR-B5MM : defaultValue can sometimes be `null` instead of undefined, which will not get
                // a value from a default param. Must use optional chaining to cover this case.
                value: value, options: options, getOptionLabel: (option) => option.label, onChange: (_, selectedOptions) => {
                    setValue(selectedOptions);
                    onChange(selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.map((option) => option.value));
                } }), _jsx(Spacer, { size: 2 }), _jsx(MerchantCategoryCodesFieldHelperText, {})] }));
};
